<div class="send-page">
  <div class="row">
    <div class="col-sm-12">
      <div class="card send-card border-0 shadow-sm">
        <!-- Header -->
        <div class="card-header send-header">
          <div class="d-flex align-items-center">
            <div class="send-logo">
              <i class="fas fa-paper-plane"></i>
            </div>
            <div class="ml-3">
              <h5 class="mb-0 font-weight-bold">Centre de messagerie</h5>
              <small class="text-muted">Gestion des envois Mail & SMS</small>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="row no-gutters">
            <!-- Sidebar -->
            <div class="col-xl-3 col-md-3 send-sidebar">
              <div class="p-3">
                <!-- Bouton Nouveau message -->
                <button class="btn btn-primary btn-block btn-compose mb-4"
                  [class.active]="activeView === 'compose'"
                  (click)="onNavigate('compose')">
                  <i class="fas fa-pen mr-2"></i> Nouveau message
                </button>

                <!-- Navigation -->
                <div class="send-nav">
                  <h6 class="text-uppercase text-muted font-weight-bold mb-3 px-2" style="font-size: 0.7rem; letter-spacing: 1px;">
                    Dossiers
                  </h6>
                  <ul class="nav flex-column">
                    <li class="nav-item">
                      <a class="nav-link send-nav-link" [class.active]="activeView === 'sent'"
                        (click)="onNavigate('sent')" href="javascript:">
                        <div class="d-flex align-items-center justify-content-between">
                          <span>
                            <i class="feather icon-send mr-2"></i> Messages envoyes
                          </span>
                          <span *ngIf="counts.envoye > 0" class="badge badge-pill badge-primary">{{ counts.envoye }}</span>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link send-nav-link" [class.active]="activeView === 'waiting'"
                        (click)="onNavigate('waiting')" href="javascript:">
                        <div class="d-flex align-items-center justify-content-between">
                          <span>
                            <i class="fas fa-clock mr-2"></i> En attente
                          </span>
                          <span *ngIf="counts.attente > 0" class="badge badge-pill badge-warning">{{ counts.attente }}</span>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link send-nav-link" [class.active]="activeView === 'trash'"
                        (click)="onNavigate('trash')" href="javascript:">
                        <div class="d-flex align-items-center justify-content-between">
                          <span>
                            <i class="feather icon-trash-2 mr-2"></i> Corbeille
                          </span>
                          <span *ngIf="counts.corbeille > 0" class="badge badge-pill badge-danger">{{ counts.corbeille }}</span>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>

                <!-- Stats rapides -->
                <div class="send-stats mt-4">
                  <h6 class="text-uppercase text-muted font-weight-bold mb-3 px-2" style="font-size: 0.7rem; letter-spacing: 1px;">
                    Statistiques
                  </h6>
                  <div class="stats-card p-3 rounded mb-2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="text-muted"><i class="fas fa-envelope mr-1"></i> Total envoyes</span>
                      <span class="font-weight-bold text-primary">{{ counts.envoye }}</span>
                    </div>
                  </div>
                  <div class="stats-card p-3 rounded mb-2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="text-muted"><i class="fas fa-hourglass-half mr-1"></i> En attente</span>
                      <span class="font-weight-bold text-warning">{{ counts.attente }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenu principal -->
            <div class="col-xl-9 col-md-9 send-content">
              <div class="p-3">

                <!-- Compose -->
                <ng-container *ngIf="activeView === 'compose'">
                  <app-send-compose [setting]="setting" (messageSent)="onMessageSent()"></app-send-compose>
                </ng-container>

                <!-- Sent -->
                <ng-container *ngIf="activeView === 'sent'">
                  <app-send-filter (filterChanged)="onFilter($event)"></app-send-filter>

                  <div class="card border-0 shadow-sm mt-3">
                    <div class="card-header bg-white border-bottom">
                      <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                          <a class="nav-link sub-tab" [class.active]="activeSubTab === 'mail'"
                            (click)="onSubTabChange('mail')" href="javascript:" role="tab">
                            <i class="fas fa-envelope mr-1"></i> Mails envoyes
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link sub-tab" [class.active]="activeSubTab === 'sms'"
                            (click)="onSubTabChange('sms')" href="javascript:" role="tab">
                            <i class="fas fa-comment-alt mr-1"></i> SMS envoyes
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="card-body p-0">
                      <app-send-list
                        [messages]="sends"
                        [loading]="loading"
                        listType="sent"
                        (showDetail)="onShowDetail($event)"
                        (moveToTrash)="onMoveToTrash($event)">
                      </app-send-list>
                    </div>
                  </div>
                </ng-container>

                <!-- Waiting -->
                <ng-container *ngIf="activeView === 'waiting'">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-white border-bottom">
                      <div class="d-flex align-items-center">
                        <i class="fas fa-clock text-warning mr-2"></i>
                        <h6 class="mb-0 font-weight-bold">Messages en attente</h6>
                      </div>
                    </div>
                    <div class="card-body p-0">
                      <app-send-list
                        [messages]="sends"
                        [loading]="loading"
                        listType="waiting"
                        (showDetail)="onShowDetail($event)"
                        (resend)="onResend($event)"
                        (moveToTrash)="onMoveToTrash($event)">
                      </app-send-list>
                    </div>
                  </div>
                </ng-container>

                <!-- Trash -->
                <ng-container *ngIf="activeView === 'trash'">
                  <div class="card border-0 shadow-sm">
                    <div class="card-header bg-white border-bottom">
                      <div class="d-flex align-items-center">
                        <i class="feather icon-trash-2 text-danger mr-2"></i>
                        <h6 class="mb-0 font-weight-bold">Corbeille</h6>
                      </div>
                    </div>
                    <div class="card-body p-0">
                      <app-send-list
                        [messages]="sends"
                        [loading]="loading"
                        listType="trash"
                        (showDetail)="onShowDetail($event)"
                        (restore)="onRestore($event)"
                        (deletePermanent)="onDeletePermanent($event)">
                      </app-send-list>
                    </div>
                  </div>
                </ng-container>

                <!-- Detail -->
                <ng-container *ngIf="activeView === 'detail'">
                  <app-send-detail
                    [message]="selectedMessage"
                    (back)="onBackToList()"
                    (resend)="onResend($event)"
                    (moveToTrash)="onMoveToTrash($event)">
                  </app-send-detail>
                </ng-container>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
